import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-transcript-dialog',
  templateUrl: './transcript-dialog.component.html',
  styleUrls: ['./transcript-dialog.component.scss']
})
export class TranscriptDialogComponent implements OnInit {
  constructor(
     public dialogRef: MatDialogRef<TranscriptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
  }
  
  get sanitizedData(): string {
    const transcript = typeof this.data === 'string'
      ? this.data
      : (this.data?.transcript ?? '');
    return transcript.replace(/\n/g, '<br>');
  }
  close(): void {
    this.dialogRef.close();
  }
}
